export default __webpack_public_path__ + "static/media/heavy-panel-outline.33c38c69.png";